export default __webpack_public_path__ + "static/media/bg2.adb0a4f1.jpg";